// Globally register all base components for convenience, because they
// will be used very frequently. Components are registered using the
// PascalCased version of their file name.

import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

const vuePath = function (_type) {
    let req;
    switch (_type) {
        case 'common':
            req = require.context('@/components/mobile/common/', false, /Mysoho[\w-]+\.vue$/)
            break;
        case 'shop':
            req = require.context('@/components/mobile/shop/', false, /Mysoho[\w-]+\.vue$/)
            break;
        case 'design':
            req = require.context('@/components/mobile/design/', false, /Mysoho[\w-]+\.vue$/)
            break;
        case 'blog':
            req = require.context('@/components/mobile/blog/', false, /Mysoho[\w-]+\.vue$/)
            break;
        case 'simple':
        default:
            req = require.context('@/components/mobile/simple/', false, /Mysoho[\w-]+\.vue$/)
            break;
    }
    return req;
}

// https://webpack.js.org/guides/dependency-management/#require-context
const requireComponent = vuePath(templateType);

// For each matching file name...
requireComponent.keys().forEach((fileName) => {
  // Get the component config
  const componentConfig = requireComponent(fileName)
  // Get the PascalCase version of the component name
  const componentName = upperFirst(
    camelCase(
      fileName
        // Remove the "./_" from the beginning
        .replace(/^\.\/_/, '')
        // Remove the file extension from the end
        .replace(/\.\w+$/, '')
    )
  )
  // Globally register the component
  Vue.component(componentName, componentConfig.default || componentConfig)
})

const requireCommonComponent = vuePath('common');
requireCommonComponent.keys().forEach((fileName) => {
  // Get the component config
  const componentConfig = requireCommonComponent(fileName)
  // Get the PascalCase version of the component name
  const componentName = upperFirst(
    camelCase(
      fileName
        // Remove the "./_" from the beginning
        .replace(/^\.\/_/, '')
        // Remove the file extension from the end
        .replace(/\.\w+$/, '')
    )
  )
  // Globally register the component
  Vue.component(componentName, componentConfig.default || componentConfig)
})
